import { TFunction } from 'i18next';
import { WarningModalProps } from '@/components/Ad/WarningModal/WarningModal';
import { Button } from '@/components/UI/Button/Button';

export const popupData = (
  t: TFunction,
  popupToggle: () => void,
  isUnblocking: boolean,
  unblock: () => Promise<void>
): Record<
  'blockedByYou' | 'blockedByOtherUser',
  Omit<WarningModalProps, 'isOpen' | 'onClose'>
> => {
  return {
    blockedByYou: {
      title: t('pages.ad.you_blocked_user'),
      description: t('pages.ad.unblock_to_continue'),
      actions: (
        <>
          <Button
            appearance="secondaryOutlined"
            isFullWidth
            disabled={isUnblocking}
            borderRadius={14}
            onClick={popupToggle}
          >
            {t('common.deny')}
          </Button>
          <Button
            appearance="secondary"
            isFullWidth
            disabled={isUnblocking}
            borderRadius={14}
            onClick={unblock}
          >
            {t('common.unblock')}
          </Button>
        </>
      ),
    },
    blockedByOtherUser: {
      title: t('pages.ad.user_unavailable'),
      description: t('pages.ad.user_restricts_access'),
    },
  };
};
